import { Request } from "@xt/xtbase";
const { XtAxios } = Request;

const URL = "/uaapi/user/";

//获取用户vip信息
export function get_privateUserVipInfo(config?) {
  return XtAxios.get(URL + `private/userVip/info`, config);
}
